import React from 'react';
import '../less/main.less';
import arrow_img from '../img/arrow_img.svg';

export default function template() {
  const { collection = [], value } = this.props;

  const selectedItem = collection.find(item => item.value === value) || collection[0];
  const dropdownItems = collection.filter(item => item.value !== selectedItem.value);

  return (
    <div
      className={`calculator-dropdown-new ${this.state.open ? 'calculator-dropdown-new_open' : ''}`}
      ref={this.dropdownRef}
    >
      <div
        className="calculator-dropdown-new__selected"
        onClick={this.toggleOpen}
        onKeyDown={(e) => e.key === 'Enter' && this.toggleOpen}
        tabIndex="0"
      >
        <span>{selectedItem.label}</span>
        <img
          className="calculator-dropdown-new__arrow"
          src={arrow_img}
          alt="arrow dropdown img"
        />
      </div>
      <div className="calculator-dropdown-new__list">
        {dropdownItems.map(item => (
          <div
            key={item.value}
            className="calculator-dropdown-new__option"
            onClick={() => this.handleSelect(item.value)}
            onKeyDown={(e) => e.key === 'Enter' && this.handleSelect(item.value)}
            tabIndex="0"
          >
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
}
